import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {createApiResponseParser} from "../../api/api-response-parser.util";
import {TechnologyParams, TechnologyResponseSchema} from "./technologies.schema";

@Injectable({ providedIn: 'root' })

export class TechnologiesApi {
  readonly #http = inject(HttpClient);
  readonly #baseUrl = environment.url;

  getTechnologies() {
    return this.#http
      .get(`${this.#baseUrl}/technologies`, {
        params: {
          ...TechnologyParams,
          'pagination[pageSize]': 100},
      })
      .pipe(map(createApiResponseParser(TechnologyResponseSchema)));
  }
}
